// src/mocks/handlers/funding/documentsDownloadHandler.ts

import { rest } from 'msw';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import { IDocumentDownloadResponse } from '@/domains/funding/documents.types';
import { isAccessTokenExpired } from '@/mocks/lib/authTokenUtils';

export const fundingDocumentsDownloadHandler =
  rest.get<IDocumentDownloadResponse>(
    `${VITE_MSW_BASE_URL}${API_ENDPOINTS.FUNDING_DOCUMENTS_DOWNLOAD}`,
    (req, res, ctx) => {
      const token = req.headers.get('Authorization');
      if (!token) {
        return res(
          ctx.status(500),
          ctx.json({ detail: 'Something went wrong' }),
        );
      }

      if (isAccessTokenExpired()) {
        return res(
          ctx.status(401),
          ctx.json({ error: 'Access token expired' }),
        );
      }

      const { customer_uuid, document_uuid } = req.params;
      /* eslint-disable no-console */
      console.log('customer_uuid', customer_uuid);
      console.log('document_uuid', document_uuid);
      return res(
        ctx.status(200),
        ctx.json({
          file_url:
            'https://app.notion.com/p/revving/Examples-of-reports-3880b27387aa808d8166cef45ffcdbc1',
        }),
      );
    },
  );
